"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const CreditBack = createSVGIcon(
  <>
    <path
      d="m16.07 18.471 4.43-1.47a2.76 2.76 0 0 1 3 1c-12.229 6.112-8.272 6.076-19 2.5L.5 23"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.5 19H15a1.016 1.016 0 1 0 0-2h-3a6.6 6.6 0 0 0-4.5-2h-3l-4 2M9.355 7.149a6.149 6.149 0 1 0 12.298 0 6.149 6.149 0 0 0-12.298 0ZM15.504 4V3"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 4h-2.03a1.342 1.342 0 0 0-.5 2.587l2.065.826a1.342 1.342 0 0 1-.5 2.587H14M15.504 11v-1"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CreditCard",
  {
    viewBox: "0 0 24 24",
    titleAccess: "CreditBack",
    fill: "none",
    strokeWidth: 1,
  }
);
